import type { FilterArrayKeys, ISearchState } from '@/components/Search/types.ts'
export const DEFAULT_PAGE_NO = 1 as const
export const DEFAULT_RECORDS_PER_PAGE = 20 as const
export const STANDARDS_RECORDS_PER_PAGE = 20 as const
export const OPENSEARCH_RESULT_WINDOW = 10000 as const
export const STANDARDS_SEARCH_TAB = 'standards' as const
export const COLLECTIONS_SEARCH_TAB = 'collections' as const
export const UPDATES_SEARCH_TAB = 'updates' as const
export const LATEST_SEARCH_TAB = 'latest' as const
export const DATE_FORMAT = 'dd/MM/yyyy' // adjust if needed
export const DEFAULT_EXPORT_FIELDS = {
    [STANDARDS_SEARCH_TAB]: [   
        'docId', 'name', 'title', 'status', 'language', 'publisher', 'country', 'latestVersion', 'versionDate', 'summary'
    ],
    [COLLECTIONS_SEARCH_TAB]: [   
        'docId', 'name', 'title', 'status', 'language', 'publisher', 'country', 'latestVersion', 'versionDate', 'summary'
    ],
    [UPDATES_SEARCH_TAB]: [   
       'update_received_at', 'update_status', 'doc_publisher_name', 'doc_name', 'doc_title', 'updated_version', 'change_summary'
    ]
};
export const MIN_QUERY_LENGTH = 3 as const;
export const MY_COLLECTION_NAME = 'myCollection' as const;

export const COLLECTIONS_FILTER_KEYS: FilterArrayKeys<ISearchState>[] = [
  `${COLLECTIONS_SEARCH_TAB}.facetFilter.collections`,
  `${COLLECTIONS_SEARCH_TAB}.facetFilter.companyCollection`,
  `${COLLECTIONS_SEARCH_TAB}.facetFilter.documentType`,
  `${COLLECTIONS_SEARCH_TAB}.facetFilter.status`,
  `${COLLECTIONS_SEARCH_TAB}.facetFilter.tags`,
  `${COLLECTIONS_SEARCH_TAB}.facetFilter.descriptorField`,
  `${COLLECTIONS_SEARCH_TAB}.facetFilter.descriptorGroup`,
  `${COLLECTIONS_SEARCH_TAB}.facetFilter.descriptorSubGroup`,
  `${COLLECTIONS_SEARCH_TAB}.facetFilter.notes`,
];

export const STANDARDS_FILTER_KEYS: FilterArrayKeys<ISearchState>[] = [
  `${STANDARDS_SEARCH_TAB}.facetFilter.searchIn`,
  `${STANDARDS_SEARCH_TAB}.facetFilter.status`,
  `${STANDARDS_SEARCH_TAB}.facetFilter.publisher`,
  `${STANDARDS_SEARCH_TAB}.facetFilter.country`,
  `${STANDARDS_SEARCH_TAB}.facetFilter.dataset`,
  `${STANDARDS_SEARCH_TAB}.facetFilter.descriptorField`,
  `${STANDARDS_SEARCH_TAB}.facetFilter.descriptorGroup`,
  `${STANDARDS_SEARCH_TAB}.facetFilter.descriptorSubGroup`,
  `${STANDARDS_SEARCH_TAB}.facetFilter.language`,
  `${STANDARDS_SEARCH_TAB}.facetFilter.year`,
  `${STANDARDS_SEARCH_TAB}.facetFilter.crossReference`
];

export const UPDATES_FILTER_KEYS: FilterArrayKeys<ISearchState>[] = [
  `${UPDATES_SEARCH_TAB}.facetFilter.what`,
  `${UPDATES_SEARCH_TAB}.facetFilter.publisher`,
  `${UPDATES_SEARCH_TAB}.facetFilter.when`,
  `${UPDATES_SEARCH_TAB}.facetFilter.dataset`,
  `${UPDATES_SEARCH_TAB}.facetFilter.dateStart`,
  `${UPDATES_SEARCH_TAB}.facetFilter.dateEnd`
]

export const SEARCH_IN_OPTIONS = [
    { "id": "0", "text": "all"},
    { "id": "1", "text": "click2view"},
    { "id": "2", "text": "watched"},
    { "id": "3", "text": "collection"}
];

export const STANDARDS_SEARCH_SORT_OPTIONS = [
  { "id": "0", "text": "relevance" },
  { "id": "3", "text": "relevanceCollectionBoost" },
  { "id": "1", "text": "alphabeticalAToZ" },
  { "id": "2", "text": "alphabeticalZToA" }
];
export const STANDARDS_SEARCH_SORT_DEFAULT = { "id": "3", "text": "relevanceCollectionBoost" };

export const COLLECTIONS_SEARCH_SORT_OPTIONS = [
  { "id": "0", "text": "relevance" },
  { "id": "1", "text": "alphabetical" }
];
export const COLLECTIONS_SEARCH_SORT_DEFAULT = { "id": "0", "text": "relevance" };

export const UPDATES_SEARCH_SORT_OPTIONS = [
  { "id": "0", "text": "latestFirst" },
  { "id": "1", "text": "oldestFirst" }
];
export const UPDATES_SEARCH_SORT_DEFAULT = { "id": "0", "text": "latestFirst" };